import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Dialog, {
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from 'material-ui/Dialog';
import Button from 'material-ui/Button';

const AccountDialog = ({
  dialogOpen,
  handleDialogClose,
  dialogTitle,
  dialogContent,
  leftButtonText,
  rightButtonText,
  leftButtonAction,
  rightButtonAction,
}) => (
  <Dialog
    open={dialogOpen}
    onClose={handleDialogClose}
    disableBackdropClick
    disableEscapeKeyDown
  >
    <DialogTitle>{dialogTitle}</DialogTitle>
    <DialogContent>
      <DialogContentText>{dialogContent}</DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button
        onClick={leftButtonAction}
        className='action-button-cancel'
        disableRipple
      >
        {leftButtonText}
      </Button>
      <Button
        onClick={rightButtonAction}
        className='action-button'
        disableRipple
      >
        {rightButtonText}
      </Button>
    </DialogActions>
  </Dialog>
);

const mapStateToProps = (state) => ({
  investorUser: state.investorUser,
});

AccountDialog.propTypes = {
  dialogOpen: PropTypes.bool.isRequired,
  handleDialogClose: PropTypes.func.isRequired,
  dialogTitle: PropTypes.string.isRequired,
  dialogContent: PropTypes.string.isRequired,
  leftButtonText: PropTypes.string.isRequired,
  rightButtonText: PropTypes.string.isRequired,
  leftButtonAction: PropTypes.func.isRequired,
  rightButtonAction: PropTypes.func.isRequired,
};

export default connect(mapStateToProps)(AccountDialog);



// WEBPACK FOOTER //
// ./src/components/Account/AccountDialog.js